import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { getUnlocalizedPath } from 'utils/localizedRouting';

export const useIsPlayingRealGame = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  return useMemo(() => {
    const isLogin = typeof window !== 'undefined' && localStorage.getItem('isLogin') === 'true';
    const isUserLoggedIn = isAuthenticated || isLogin;
    if (!isUserLoggedIn) return false;

    const unlocalizedPath = getUnlocalizedPath(location.pathname);
    if (!unlocalizedPath.startsWith('/game/casino/')) return false;

    const state = location.state as { isDemo?: boolean } | null;
    if (state && state.isDemo !== undefined) {
      return !state.isDemo;
    }

    const gameMatch = unlocalizedPath.match(/\/game\/casino\/([^/?#]+)/);
    const game = gameMatch ? gameMatch[1] : null;
    if (game) {
      try {
        const savedState = sessionStorage.getItem(`game_state_${game}`);
        if (savedState) {
          const parsed = JSON.parse(savedState);
          if (parsed.isDemo !== undefined) {
            return !parsed.isDemo;
          }
        }
      } catch (e) {
        // ignore
      }
    }

    return true;
  }, [location.pathname, location.state, isAuthenticated]);
};
